import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

const DEFAULT_CONTENT = {
  mediaText: 'KTS鹿児島テレビ「SUPER EIGHT 安田章大の人生って最高だ」にてタイトル文字制作を担当。',
  links: [
    { label: 'Instagram', handle: '@koureiansaiun', url: 'https://www.instagram.com/koureiansaiun' },
    { label: 'Facebook', handle: '書 創作 虹嶺庵 彩雲', url: 'https://www.facebook.com' },
    { label: 'Creema', handle: 'ハンドメイド作品の販売', url: 'https://www.creema.jp' },
  ],
};

export default function ActivitiesSection() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'siteContent', 'activities'), (snap) => {
      if (snap.exists()) {
        setContent({ ...DEFAULT_CONTENT, ...snap.data() });
      }
    });
    return unsubscribe;
  }, []);

  return (
    <section id="activities" className="pf-section pf-activities">
      <div className="pf-section__head">
        <p className="pf-section__eyebrow">ACTIVITIES</p>
        <h2 className="pf-section__title">活動</h2>
      </div>

      <div className="pf-activities__media">
        <p className="pf-activities__media-label">MEDIA</p>
        <p className="pf-activities__media-text">{content.mediaText}</p>
      </div>

      <div className="pf-activities__links">
        {content.links.map((l, i) => (
          <a key={i} className="pf-activities__link" href={l.url} target="_blank" rel="noreferrer">
            <span className="pf-activities__link-label">{l.label}</span>
            <span className="pf-activities__link-handle">{l.handle}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
